<template>
  <div class="col-sm-12">
    <div :id="chartId" class="container-chart">
      <div class="lds-ripple" v-if="isDataLoading">
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from 'd3'
import d3Tip from 'd3-tip'
import { utilsMixin, chartMixin } from '../../utils/mixins'
import { RotationChart } from '../../utils/charts/RotationChart'

export default {
  name: 'RotationChart',
  dependencies: ['dataService'],
  mixins: [utilsMixin, chartMixin],
  data() {
    return {
      dataset: {},
      margin: { top: 20, right: 20, bottom: 30, left: 50 },
      width: 960,
      height: 500,
      radius: 200,
      svgWidth: 960,
      svgHeight: 500,
      gridSize: 0,
      svg: Object(),
      tooltip: Object(),
      chart: Object(),
      area: Object(),
      xAxis: Object(),
      yAxis: Object(),
      xAxisScale: null,
      yAxisScale: null,
      colors: ['#ffffff', '#ffffd9', '#c7e9b4', '#41b6c4', '#253494'],
      savedStart: null,
      savedEnd: null,
    }
  },
  props: ['config', 'chartId', 'period'],
  mounted() {
    d3.tip = d3Tip
    this.chart = new RotationChart(
      this.chartId,
      this.dataset,
      this.config.type,
      960,
      500,
      null,
      this.$t,
    )
    this.chart.initContainer(this.chartId)
    this.chart.setTitles(this.config.titles[this.$locale])

    this.savedStart = this.period[0]
    this.savedEnd = this.period[1]
  },
  watch: {
    config: {
      handler: function() {
        this.loadConfigAndFetchData()
      },
      immediate: true,
    },
    period: {
      handler: function(period) {
        if (period[0] != this.savedStart || period[1] != this.savedEnd) {
          this.savedStart = this.period[0]
          this.savedEnd = this.period[1]
          this.loadConfigAndFetchData()
        }
      },
    },
  },
  methods: {
    loadConfigAndFetchData: function() {
      this.requestCount++

      this.dataService
        .getChartData(
          this.config,
          this.period,
          this.dateFormat,
          this.getCurrentUser,
          this.currentRequestId,
        )
        .then(data => {
          this.$emit('update', {
            chart_id: this.config.id,
            data: JSON.parse(JSON.stringify(data.result)),
          })
          this.dataset = data.result
          this.processData()
          this.chart.draw()
          this.requestCount--
        })
        .catch(e => {
          if (e.message != 'cancel') {
            console.error('IndicatorChart error', e)
            this.dataLoadedError = true
          }
          this.requestCount--
        })

      this.currentRequestId = this.getRequestId(
        this.config,
        this.period,
        this.dateFormat,
        this.getCurrentUser,
      )
    },
    processData: function() {
      //We add distribution in percent for each rotations gap
      this.dataset.items.sort((a, b) => {
        return b.count - a.count
      })
      this.dataset['distribution'] = []
      this.dataset.items.forEach(item => {
        var r = this.dataset.distribution.find(i => {
          return i.rotations == Math.round(item.count / this.dataset.days)
        })

        item['rotation'] = Math.round(item.count / this.dataset.days)

        if (r) {
          r['count'] += 1
        } else {
          r = {
            count: 1,
            rotations: Math.round(item.count / this.dataset.days),
          }
          this.dataset.distribution.push(r)
        }
      })

      this.dataset.distribution.forEach(r => {
        r['percent'] = Math.round((r.count / this.dataset.items.length) * 100)
      })

      this.chart.setDataset(this.dataset)
      this.chart.setSortedDataset(this.dataset)
      this.chart.setConfig(this.config)

      this.chart.initTooltip()
    },
  },
}
</script>

<style>
rect.bordered {
  stroke: #e6e6e6;
  stroke-width: 2px;
}
</style>
